import styled from 'styled-components';
import { Table } from 'components/Table';

import {
  colorGrey400,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryLaptopMin,
  mediaQueryMobileLargeMin,
} from 'styles';

import { H2, Paragraph } from 'components/Typography';
import {
  CurrContent,
  Currency,
  DiffWrapper,
  TableFooter,
} from 'components/Table/styles';

export const Title = styled(H2)`
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  line-height: 24px;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
  }
`;
export const CurrencyWrapper = styled.section`
  width: 100%;
  position: relative;
  background: ${colorWhite};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
  padding: 16px;

  @media all and ${mediaQueryMobileLargeMin} {
    padding: 24px;
  }
`;

export const TextDescription = styled.div`
  margin: 8px 0;
  font-weight: 400;
  font-family: ${fontFamilyPrimary};
  font-size: 16px;
  line-height: 24px;
  width: 100%;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 14px;
    margin: 8px 16px;
  }
`;

export const CurrencyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: flex-start;
  }
`;
export const SubTitle = styled.h1`
  font-family: ${fontFamilySecondary};
  font-size: 14px;
  line-height: 24px;
  color: ${colorGrey400};
  font-weight: 700;
`;
export const WrapperRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  margin-top: 16px;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-top: 0;
  }

  @media ${mediaQueryLaptopMin} {
    align-items: flex-end;
    gap: 8px;
  }
`;
export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  width: 100%;

  & button {
    height: 40px;
    line-height: 39px;
    width: 100%;
    max-width: 100%;
    margin: 0;
  }

  & > div,
  & > button {
    margin: 0;
    min-width: 160px;
    width: 100%;
    max-width: 100%;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    justify-content: center;
    width: auto;

    & button {
      margin: 0;
      width: 200px;
      max-width: max-content;
    }
  }
`;
export const CurrencySelectWrapper = styled.div`
  height: 48px;
  display: flex;
  align-items: center;

  @media all and ${mediaQueryMobileLargeMin} {
    height: auto;
    display: block;
  }
`;
export const Source = styled(Paragraph)`
  color: ${colorGrey400};
  line-height: 16px;

  ${({ mode }) => {
    if (mode === 'mobile') {
      return `
       display: block;
       
        @media all and ${mediaQueryMobileLargeMin} {
          display: none;
        }
      `;
    }
    if (mode === 'desktop') {
      return `
       display: none;
       
        @media all and ${mediaQueryMobileLargeMin} {
          display: block;
        }
      `;
    }
    return '';
  }}
`;

export const TablesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 16px;
`;

export const TableColumn = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;

  @media all and ${mediaQueryMobileLargeMin} {
    border-top: 1px solid #e6e6e6;
  }
`;

export const TableAverage = styled(Table)`
  display: flex;
  flex: 1;
  order: 1;

  @media all and ${mediaQueryMobileLargeMin} {
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;

    tr:nth-child(odd) {
      background-color: #fbfbfb;
    }
  }

  th {
    text-align: right !important;
    padding: 4px 16px;
  }
  td {
    padding: 0 16px;
  }

  ${DiffWrapper} {
    margin-top: 2px;
  }

  ${Currency} {
    width: auto;
  }

  tbody tr:last-child {
    box-shadow: none;
  }

  ${CurrContent} {
    align-items: flex-end;
    flex-direction: column;
    font-size: 16px;
  }
`;

export const TableCash = styled(TableAverage)`
  @media all and ${mediaQueryMobileLargeMin} {
    & td:first-child,
    th:first-child {
      display: none;
    }
  }
`;
export const TableColumnCash = styled(TableColumn)`
  order: 3;

  @media all and ${mediaQueryMobileLargeMin} {
    border-left: 1px solid #e6e6e6;
    order: 2;
    & > ${TextDescription} {
      text-align: center;
    }
  }
`;

export const TableFooterAverage = styled(TableFooter)`
  order: 2;
  flex-direction: column-reverse;
  align-items: flex-start;
  @media all and ${mediaQueryMobileLargeMin} {
    order: 3;
    flex-direction: row;
  }
`;
export const TableFooterCash = styled(TableFooter)`
  order: 4;
  @media all and ${mediaQueryMobileLargeMin} {
    display: none;
  }
`;
